import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/homeabout.css";

const HomeAbout = () => {
  return (
    <section id="about" className="about-section py-5">
      <div className="container">
        <div className="row align-items-center g-5">
          {/* Text Content */}
          <div className="col-lg-6">
            <div className="about-content">
              <h2 className="about-title fw-bold mb-4">Who We Are?</h2>
              <div className="about-text">
                <p className="mb-3">
                  BCAS is a leading air conditioning sales & service provider with over
                  18 years of experience. We take pride in being a trusted partner of
                  Mitsubishi Electric and a multi-brand dealer, ensuring top-quality solutions.
                </p>
                <p className="mb-4">
                  Our dedication to customer service has helped us build long-lasting
                  relationships, making us the go-to choice for air conditioning needs.
                </p>
              </div>
              <a href="/about" className="about-btn">
                Learn More About Us
                <i className="bi bi-arrow-right ms-2"></i>
              </a>
            </div>
          </div>
          
          {/* Image */}
          <div className="col-lg-6">
            <div className="about-image-wrapper">
              <img
                src="https://public.readdy.ai/ai/img_res/0a8af7ee8cdc6fc945240df92a3f690e.jpg"
                alt="Professional Team"
                className="about-image"
              />
              <div className="about-image-shape"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeAbout;